import { assert } from '../../lib/assert-sidecar'
import { common } from '../../main/common-sidecar'
import { voyageAstar } from './voyageAstar-sidecar'
import { EVoyageCarryableType } from './voyageCarryable'
import { IVoyageCrew, moveToIJ } from './voyageCrew'
import { voyageSounds } from './voyageSounds-sidecar'
import { EVoyageTile } from './voyageTileData'
import { voyageTilemap } from './voyageTilemap-sidecar'

export const footstepTime = 0.25
export const moveTime = 0.25
export const coffeeMultiplier = 0.5
const elevatorMoveTime = 0.5

export function update(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()

  if (obj.path) {
    let ps = obj.path.path
    if (ps.length > 0) {
      obj.moveTimer += ds

      obj.footstepTimer += ds
      if (obj.footstepTimer > footstepTime) {
        obj.footstepTimer -= footstepTime
        // voyageSounds.playFootstep()
      }

      let moveMultiplier = 1
      if (obj.carryable && obj.carryable.type === EVoyageCarryableType.Coffee) {
        moveMultiplier *= coffeeMultiplier
      }
      let curMoveTime = moveTime * moveMultiplier

      if (obj.moveTimer > curMoveTime) {
        let nextStep = ps[obj.pathIdx]
        if (nextStep) {
          let tCur = voyageTilemap.getSafe(obj.i, obj.j)
          assert.notNil(tCur, 'tnext is null?')
          if (tCur.tile3.type === EVoyageTile.Elevator) {
            curMoveTime = elevatorMoveTime
          }
          if (obj.moveTimer > curMoveTime) {
            obj.moveTimer -= curMoveTime
            obj.pathIdx++
            moveToIJ(obj, nextStep)
            voyageSounds.playFootstep()
          }
        } else {
          obj.path = null
        }
      }
    }
  }
}

export function pathTo(obj: IVoyageCrew, i: number, j: number) {
  let tStart = voyageTilemap.getSafe(obj.i, obj.j)
  let tEnd = voyageTilemap.getSafe(i, j)
  obj.path = null

  if (tEnd && tStart) {
    if (tEnd.tile2.canWalk) {
      obj.path = voyageAstar.findPath(tStart, tEnd)
      obj.pathIdx = 1
      obj.moveTimer = moveTime / 2
      // console.log('pathfound', r)
    }
  }
}
